import type { TLPointerEventHandler, TLKeyboardEventHandler } from '@tldraw/core'
import {TDShapeType} from '@modules/whiteboard/shapes/types'
import {BaseTool} from '@modules/whiteboard/tools/BaseTool'
import { action } from '@api'
import Vec from '@tldraw/vec'

export class TextTool extends BaseTool {
  type = 'text' as const

  /* --------------------- Methods -------------------- */

  @action stopEditingShape = () => {
    console.debug(`stopEditingShape - text`)
    this.status = 'idle'

    if (!this.appState.isToolLocked) {
      // this.app.selectTool('select')
    }
  }

  /* ----------------- Event Handlers ----------------- */

  @action onKeyUp: TLKeyboardEventHandler = () => {
    // noop
  }

  @action  onKeyDown: TLKeyboardEventHandler = () => {
    // noop
  }

  @action onPointerDown: TLPointerEventHandler = () => {
    console.debug(`onPointerDown - text`)
    if (this.status === 'creating') {
      this.stopEditingShape()
      return
    }

    if (this.status === 'idle') {
      const { app: {currentPoint: point, grid} } = this
      this.app.createTextShapeAtPoint(grid ? Vec.snap(point, grid) : point)
      this.status = 'creating'
      return
    }
  }

  @action onPointerUp: TLPointerEventHandler = () => {
    // noop important! We don't want the inherited event
    // from BaseUtil to run.
    this.app.selectTool('select')
  }

  @action onPointShape: TLPointerEventHandler = (info) => {
    console.debug(`onPointShape - text`)
    const shape = this.app.getShape(info.target)
    if (shape.type === 'text') {
      this.status = 'idle'
      this.app.appState.editingId = shape.id
    }
  }

  @action onShapeBlur = () => {
    console.debug(`onShapeBlur - text`)
    this.stopEditingShape()
  }
}



// WEBPACK FOOTER //
// ./src/modules/whiteboard/tools/TextTool/TextTool.ts